import React, { Component } from 'react'
import Button from 'react-bootstrap/Button'

import { ButtonProps } from '@types'

interface Props {
  title: string
  buttons?: ButtonProps[]
}
export default class Header extends Component<Props> {
  renderButton = (buttonProps: ButtonProps, index: number) => {
    const { title, href, onClick } = buttonProps
    return (
      <Button key={`${title}-${index}`} variant="primary" href={href} onClick={onClick}>
        {title}
      </Button>
    )
  }

  render() {
    const { title, buttons } = this.props
    return (
      <header className="sq-page-header">
        <div className="sq-page-header__heading">
          <span className="sq-page-header__eyebrow">Gestionale autori</span>
          <h1 className="sq-page-header__title">{title}</h1>
        </div>
        {buttons && buttons.length > 0 && (
          <div className="sq-page-header__actions">{buttons.map(this.renderButton)}</div>
        )}
      </header>
    )
  }
}
